import { OUI_NON_NSP } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case OUI_NON_NSP.OUI:
        return 'Oui';
      case OUI_NON_NSP.NON:
        return 'Non';
      case OUI_NON_NSP.NE_SAIT_PAS:
        return 'Je ne sais pas';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/oui-non-nsp.filter.js